export default "__VITE_ASSET__BJz2PMo2__"